import React from "react";
import { ArrowRight, Mail } from "lucide-react";
import { Button } from "../ui/button";

export const FormationsContactBlock = ({ contactBlock }) => {
  if (!contactBlock?.isActive) return null;

  return (
    <section className="px-4 pb-16 pt-8 sm:px-6 lg:px-8 lg:pb-24" data-testid="formations-contact-section">
      <div className="mx-auto max-w-5xl overflow-hidden rounded-[2.8rem] border border-[#1d4ed8]/15 bg-[linear-gradient(135deg,_#0f766e_0%,_#0f4c81_50%,_#0f172a_100%)] px-6 py-10 text-white shadow-[0_40px_100px_-58px_rgba(15,76,129,0.5)] sm:px-10 sm:py-12 lg:px-14 lg:py-14">
        <div className="text-center">
          <div className="text-sm font-semibold uppercase tracking-[0.22em] text-[#bfdbfe]" data-testid="formations-contact-eyebrow">
            Contact
          </div>
          <h2 className="bim-display mt-4 text-4xl font-semibold tracking-tight sm:text-5xl" data-testid="formations-contact-title">
            {contactBlock.title}
          </h2>
          <p className="mx-auto mt-5 max-w-3xl text-base leading-8 text-slate-100 sm:text-lg" data-testid="formations-contact-description">
            {contactBlock.description}
          </p>
        </div>

        <div className="mt-8 flex flex-col items-center justify-center gap-4 sm:flex-row" data-testid="formations-contact-actions">
          <Button asChild className="h-12 rounded-full bg-white px-6 text-[#0f4c81] hover:bg-slate-100">
            <a data-testid="formations-contact-primary-button" href={contactBlock.primaryHref}>
              {contactBlock.primaryLabel}
              <ArrowRight className="ml-2 h-4 w-4" />
            </a>
          </Button>
          <Button asChild className="h-12 rounded-full border-white/25 bg-white/10 px-6 text-white hover:bg-white/15" variant="outline">
            <a data-testid="formations-contact-secondary-button" href={contactBlock.secondaryHref}>
              <Mail className="mr-2 h-4 w-4" />
              {contactBlock.secondaryLabel}
            </a>
          </Button>
        </div>
      </div>
    </section>
  );
};